<script lang="ts">
    import cn from 'classnames';

    import LL from '@i18n/i18n-svelte';
    import { URLS } from '@shared/routing';
    import { Link } from '@uikit/link';

    import { getLogo } from './functions';

    import s from './logo.module.css';

    import { page } from '$app/stores';

    export let classes = '';
    export let link = URLS.index();
    export let flag: string | null = null;

    const isDisabledClick = $page.url.pathname.includes(URLS.talkToStrangers());

    let logo: { src: string; alt: string };
    $: logo = getLogo($LL, $page.url.pathname);
</script>
<Link on:click classes={cn(s.logoContainer, classes)} href={isDisabledClick ? undefined : link}>
    <img class={s.logo} src={logo.src} width="109" height="26" alt={logo.alt} />
    {#if flag}
        <img class={s.flag} src={`/icons/flags/${flag}.svg`} width="24" alt={flag} />
    {/if}
</Link>
